import { GlToastMixin } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';

const instance = new Vue({ name: 'GlobalToastRoot', mixins: [GlToastMixin], render: () => null });

export default function showGlobalToast(...args) {
  return instance.$toast.show(...args);
}
